import axios from 'axios';

export function traerConfiguracionBackend(vieneDePlazoFijoWeb, vieneDeUV){
    return new Promise((resolve, reject) => {
        /*
        if (process.env.REACT_APP_API_URL != null 
            && process.env.REACT_APP_API_URL != '' 
            && process.env.REACT_APP_PRENDIDO_PLAZO_FIJO_WEB != null
            && process.env.REACT_APP_PRENDIDO_PLAZO_FIJO_WEB.trim() == 'true'
            ) {
            localStorage.setItem('url', process.env.REACT_APP_API_URL.trim());
            
            resolve({
                message: 'OK'
            })  
            return;
        }
        if (process.env.REACT_APP_PRENDIDO_PLAZO_FIJO_WEB != null && !process.env.REACT_APP_PRENDIDO_PLAZO_FIJO_WEB.trim() != 'true') {
            localStorage.setItem('url', '');
        }*/
        // if (localStorage.getItem('url') == null) {
            localStorage.setItem('url', '');
            axios({
                method: 'get',
                url: '/api/plazoFijo/configuracionBackendUnificado'
            }).then((response) => {
                if (response.status === 200) {
                    if (response.data.prendidoPlazoFijoWeb && vieneDePlazoFijoWeb){
                        localStorage.setItem('url', response.data.url);
                    }
                    if (response.data.prendidoVU && vieneDeUV){
                        localStorage.setItem('url', response.data.url);
                    }
                } 
                resolve({
                    message: 'OK'
                })   
            }).catch(error => {
                reject({
                    message: 'error'
                });
            });
        /*} else {
            resolve({
                message: 'OK'
            })   
        }*/
    });
}



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/Utils/BackendUnificado.js